var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ path: '/item/' + this.hyphenate(_vm.item.name) },"data-id":_vm.item.id},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.item.name.toLowerCase()))])}
var staticRenderFns = []

export { render, staticRenderFns }